import React, { useMemo } from 'react';

// DEPENDENCIES
import { compose } from 'redux';
import { connect } from 'react-redux';
import isArray from 'lodash/isArray';
import sortBy from 'lodash/sortBy';
import isEqual from 'lodash/isEqual';

// MAIN COMPONENT
const DealershipsCell = compose(connect(({ user }) => ({ user })))(
  ({
    user: { stores },
    value,
    row: {
      original: { is_global }
    },
    placeholder
  }) => {
    const dealershipsLabel = useMemo(() => {
      if (!value && is_global) return 'All';
      if (!value && !is_global) return placeholder;

      const dealerIds = isArray(value) ? value : (value || '').split(',');

      const storesDX = sortBy(dealerIds.map(id => Number(id)));
      const userStoresIds = sortBy(stores.map(store => store?.make_dealer_id));

      if (isEqual(storesDX, userStoresIds)) {
        return 'All';
      }

      const result = stores
        .filter(store => storesDX.includes(store?.make_dealer_id))
        .map(store => store?.dealer_name)
        .join(', ');

      return result || placeholder;
    }, [value, stores, is_global, placeholder]);

    return <span>{dealershipsLabel}</span>;
  }
);

export default DealershipsCell;
